// extracted by mini-css-extract-plugin
export default {"m":"_78bab5a385","title":"ddd669eeda","feedback_inner_title":"_329a786ff5","textarea":"_950063f6d9","radio":"b146bfa640","text":"_431e52c7fe"};